export const actionTypes: any = {
  // MENU BREADCRUMB OPTION
  GET_MENU_BREADCRUMB_OPTION_START: 'GET_MENU_BREADCRUMB_OPTION_START',
  GET_MENU_BREADCRUMB_OPTION_SUCCESS: 'GET_MENU_BREADCRUMB_OPTION_SUCCESS',
  GET_MENU_BREADCRUMB_OPTION_FINISH: 'GET_MENU_BREADCRUMB_OPTION_FINISH',

  //GET MENU ICON TYPE CONSTANTS
  GET_MENU_ICON_TYPE_START: 'GET_MENU_ICON_TYPE_START',
  GET_MENU_ICON_TYPE_SUCCESS: 'GET_MENU_ICON_TYPE_SUCCESS',
  GET_MENU_ICON_TYPE_FINISH: 'GET_MENU_ICON_TYPE_FINISH',

  //GET MENU LINK TYPE CONSTANTS
  GET_MENU_LINK_TYPE_START: 'GET_MENU_LINK_TYPE_START',
  GET_MENU_LINK_TYPE_SUCCESS: 'GET_MENU_LINK_TYPE_SUCCESS',
  GET_MENU_LINK_TYPE_FINISH: 'GET_MENU_LINK_TYPE_FINISH',

  //GET MENU STATUS CONSTANTS
  GET_MENU_STATUS_START: 'GET_MENU_STATUS_START',
  GET_MENU_STATUS_SUCCESS: 'GET_MENU_STATUS_SUCCESS',
  GET_MENU_STATUS_FINISH: 'GET_MENU_STATUS_FINISH',

  //GET MENU TYPE CONSTANTS
  GET_MENU_TYPE_START: 'GET_MENU_TYPE_START',
  GET_MENU_TYPE_SUCCESS: 'GET_MENU_TYPE_SUCCESS',
  GET_MENU_TYPE_FINISH: 'GET_MENU_TYPE_FINISH',

  //GET MENU VISIBILITY STATUS CONSTANTS
  GET_MENU_VISIBILITY_STATUS_START: 'GET_MENU_VISIBILITY_STATUS_START',
  GET_MENU_VISIBILITY_STATUS_SUCCESS: 'GET_MENU_VISIBILITY_STATUS_SUCCESS',
  GET_MENU_VISIBILITY_STATUS_FINISH: 'GET_MENU_VISIBILITY_STATUS_FINISH',

  //GET MENU TOP MENU CONSTANTS
  GET_TOP_MENU_START: 'GET_TOP_MENU_START',
  GET_TOP_MENU_SUCCESS: 'GET_TOP_MENU_SUCCESS',
  GET_TOP_MENU_FINISH: 'GET_TOP_MENU_FINISH',

  //GET MENU TOP LEFT MENU CONSTANTS
  GET_TOP_LEFT_MENU_START: 'GET_TOP_LEFT_MENU_START',
  GET_TOP_LEFT_MENU_SUCCESS: 'GET_TOP_LEFT_MENU_SUCCESS',
  GET_TOP_LEFT_MENU_FINISH: 'GET_TOP_LEFT_MENU_FINISH',

  //GET MENU DATA CONSTANTS
  GET_MENU_START: 'GET_MENU_START',
  GET_MENU_SUCCESS: 'GET_MENU_SUCCESS',
  GET_MENU_FINISH: 'GET_MENU_FINISH',

  //GET MENU DATA CONSTANTS
  GET_ALL_MENU_START: 'GET_ALL_MENU_START',
  GET_ALL_MENU_SUCCESS: 'GET_ALL_MENU_SUCCESS',
  GET_ALL_MENU_FINISH: 'GET_ALL_MENU_FINISH',

  //ADD MENU CONSTANTS
  ADD_MENU_START: 'ADD_MENU_START',
  ADD_MENU_SUCCESS: 'ADD_MENU_SUCCESS',
  ADD_MENU_FINISH: 'ADD_MENU_FINISH',
  ADD_MENU_RESET: 'ADD_MENU_RESET',

  //UPDATE MENU CONSTANTS
  UPDATE_MENU_START: 'UPDATE_MENU_START',
  UPDATE_MENU_SUCCESS: 'UPDATE_MENU_SUCCESS',
  UPDATE_MENU_FINISH: 'UPDATE_MENU_FINISH',

  // delete MENU
  DELETE_MENU_START: 'DELETE_MENU_START',
  DELETE_MENU_SUCCESS: 'DELETE_MENU_SUCCESS',
  DELETE_MENU_FINISH: 'DELETE_MENU_FINISH',

  // Enable MENU
  ENABLE_MENU_REQUEST: 'ENABLE_MENU_REQUEST',
  ENABLE_MENU_SUCCESS: 'ENABLE_MENU_SUCCESS',
  ENABLE_MENU_FINISH: 'ENABLE_MENU_FINISH',

  // Disable MENU
  DISABLE_MENU_REQUEST: 'DISABLE_MENU_REQUEST',
  DISABLE_MENU_SUCCESS: 'DISABLE_MENU_SUCCESS',
  DISABLE_MENU_FINISH: 'DISABLE_MENU_FINISH',

  // Enable MENU
  SINGLE_ENABLE_MENU_REQUEST: 'SINGLE_ENABLE_MENU_REQUEST',
  SINGLE_ENABLE_MENU_SUCCESS: 'SINGLE_ENABLE_MENU_SUCCESS',
  SINGLE_ENABLE_MENU_FINISH: 'SINGLE_ENABLE_MENU_FINISH',

  // Disable MENU
  SINGLE_DISABLE_MENU_REQUEST: 'SINGLE_DISABLE_MENU_REQUEST',
  SINGLE_DISABLE_MENU_SUCCESS: 'SINGLE_DISABLE_MENU_SUCCESS',
  SINGLE_DISABLE_MENU_FINISH: 'SINGLE_DISABLE_MENU_FINISH',

  // sort
  SORT_MENU_START: 'SORT_MENU_START',
  SORT_MENU_SUCCESS: 'SORT_MENU_SUCCESS',
  SORT_MENU_FINISH: 'SORT_MENU_FINISH',
  SORT_MENU_RESET: 'SORT_MENU_RESET',
}
